import Utils from "../../services/Utils.js";

const currencies = {
  '1': 'EUR',
  '2': 'LEK',
  '3': 'USD',
  '4': 'CHF',
  '5': 'GBP',
  '6': 'MKD'
};

export function getAccountBalanceTemplate(account_balance, role) {
  const nonSportTypes = ['casino', 'livecasino', 'casino/slots', 'virtual', 'aviator'];
  const type = account_balance.type.toLowerCase();
  let currency = $('#accountBalanceUserCoinSelect').val();
  if (currency) {
    currency = ' ' + currencies[currency];
  } else {
    currency = '';
  }

    return `<div class="accountBalanceRow 
    ${role != "User" ? 'fiveColumnsHolder' : ''}
    ${role == "User" ? (nonSportTypes.indexOf(type) !== -1 ? 'fiveColumnsHolder' : 'fourColumnsHolder') : ''}
    ">
    ${
      role != "User"
        ? `<span>${account_balance.username}</span>`
        : "<span>*</span>"
    }
    <span> ${
    Utils.formatNumber(account_balance.stake ? account_balance.stake : 0)
  }</span>
    
    <span>${Utils.formatNumber( account_balance.win ? account_balance.win : 0)}</span>
    ${nonSportTypes.indexOf(type) !== -1 ?  `<span>${(Utils.formatNumber(account_balance.jackpot ? account_balance.jackpot : 0))}</span>` : ""}
    
    ${
      role != "User" && type == "baste"
        ? `<span>${Utils.formatNumber(
            account_balance.percentage
              ? account_balance.percentage
              : 0)}</span>`
        : ""
    }
    
    ${
        role != "User"
            ? `<span>${Utils.formatNumber(
            account_balance.difference
                ? account_balance.difference
                : 0
            , currency)}</span>`
            : ""
    }
    ${
      role == "User"
          ? `<span>${Utils.formatNumber(
          account_balance.difference
              ? account_balance.difference
              : 0)}</span>`
          : ""
  }
</div>`;
}

export function getSmFinanceTemplate(account_balance) {
  let currency = $('#accountBalanceUserCoinSelect').val();
  if (currency) {
    currency = ' ' + currencies[currency];
  } else {
    currency = '';
  }

  return `<div class="accountBalanceRow">
   <span style="width:16%;">${account_balance.username}</span>
      
  <span style="width:14%;">${
    Utils.formatNumber(account_balance.dif_sport ? account_balance.dif_sport : 0, currency)
  }</span>
  <span style="width:14%;">${
    Utils.formatNumber(account_balance.dif_sport_mng ? account_balance.dif_sport_mng : 0, currency)
  }</span>
  <span style="width:14%;">${
    Utils.formatNumber(account_balance.dif_casino ? account_balance.dif_casino : 0, currency)
  }</span>
  <span style="width:14%;">${
    Utils.formatNumber(account_balance.dif_livecasino ? account_balance.dif_livecasino : 0, currency)
  }</span>
  <span style="width:14%;">${
    Utils.formatNumber(account_balance.dif_virtual ? account_balance.dif_virtual : 0, currency)
  }</span>
  <span style="width:14%;">${
    Utils.formatNumber(account_balance.difference ? account_balance.difference : 0, currency)
  }</span>
</div>`;
}